<template>

    <div class="relative">
        <Header />

       
        <div
        class="container mx-auto max-w-[1200px] w-full py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-8"
        >
         <div class="flex gap-6 justify-end  px-10">  
            <div @click="this.$router.go(-1)" class="">
              <div
                class="mb-1 cursor-pointer rounded-lg flex border justify-center w-24 gap-2 items-center py-1 bg-white"
              >
                <div class="text-sm text-gray-700 hover:text-teal-500" title="back">
                  back
                </div>
                <div class="flex items-center">
                  <img
                    src="https://img.icons8.com/external-simple-solid-edt.graphics/15/undefined/external-Back-arrows-simple-solid-edt.graphics-2.png"
                  />
                </div>
              </div>
            </div>
          </div>


         <div class="flex flex-col gap-2 lg:gap-4 lg:flex-row lg:justify-between w-full"
                            style="overflow-x: scroll;">
            <table class="border  w-full">
                <thead>
                    <tr class="">
                        <td class="bg-gray-200 p-2 font-bold" style="width: 300px;">Title</td>
                        <td class="bg-gray-200 p-2 font-bold" style="width: 300px;">Code</td>
                        <td class="bg-gray-200 p-2 font-bold hidden" style="width: 300px;">Preview</td>
                        <td class="bg-gray-200 p-2 font-bold" style="width: 300px;">Re-Generate</td>
                        <td class="bg-gray-200 p-2 font-bold" style="width: 300px;">Course Preview</td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-sm" v-for="(course, index) in promptListCourse" :key="index">
                        <td class="p-2 text-lg">{{ course.title }}</td>
                        <td class="p-2 text-lg">{{ course.code }}</td>
                        <td class="p-2 hidden"><button class="bg-[#0f172a] text-white text-xs rounded-lg px-4 py-2 mt-4"
                                @click="openPreviewPopup(course.id)">Course Parameter View</button></td>
                        <td class="p-2"><button class="bg-[#0f172a] text-white text-xs rounded-lg px-4 py-2 mt-4"
                                @click="tiggerGemimi(course.id)">Re-Generate</button></td>

                              
                        <td class="p-2">
                             <router-link
                                :to="{ name: 'GeminiPreview', params: { course_id: course.id } }">
                                <button class="bg-[#0f172a] text-white text-xs rounded-lg px-4 py-2 mt-4"> Generate Course View</button>
                            </router-link>
                        </td>
                        <!-- <td class="p-2"> <button class="gradient-btn" @click="openCoursePreview(course.id)">  Generate Course View</button></td> -->
                    </tr>
                </tbody>
            </table>
        </div>    
        </div> 


        <div v-if="popup_regenerate"
            class="fixed top-0 left-0 z-50 bg-black bg-opacity-60 h-screen w-full flex items-center">
            <div class="relative w-auto mx-auto rounded-lg bg-white p-4 lg:p-6 text-gray-700 text-center shadow-xl">
                <!-- <div
                @click="popup_regenerate = false"
                class="absolute right-4 top-0 text-6xl text-right font-light primary-text-color cursor-lg cursor-pointer"
            >
                &times;
            </div> -->


                <h2 v-if="regenerate_status" class="p-4 text-lg font-semibold capitalize">{{ regenerate_message }}</h2>
                <h2 v-else class="p-4 text-lg font-semibold capitalize">Your code is Regenerating ...</h2>
                <div v-if="loader" class="flex flex-col justify-center items-center">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    Regenerating...
                </div>

                <button v-if="regenerate_status" type="submit" class="gradient-btn mt-4"
                    @click="popup_regenerate = false">
                    Close
                </button>
            </div>
        </div>


        <div v-if="popupforPreview"
                        class="w-full h-full mx-auto fixed top-0 left-0 bg-black bg-opacity-75 p-4 flex items-center"
                        style="z-index: 5000">
                        <div
                            class="flex justify-center items-center bg-white mx-auto w-full lg:max-w-4xl 2xl:max-w-5xl rounded-lg relative !z-999 p-5 pt-5 text-3xl font-bold ">
                            <div class="p-4 w-full text-lg">
                                <div class="flex justify-between">
                                    <p class="text-lg">Edit</p>




                                    <div @click="popupforPreview = false"
                                        class="cursor-pointer flex rounded-lg bg-white">
                                        <!-- <h1 class="px-1 md:px-2 py-1 text-sm md:text-base hover:text-red-500">Close</h1> -->
                                        <img class='h-5 w-5 md:h-8 md:w-8 my-auto lg:my-0'
                                            src="@/assets/closebutton.svg" />
                                    </div>
                                </div>
                                <form action="" @submit.prevent="coursePromptUpdate" class="">
                                    <div class="flex flex-col gap-2 h-96 overflow-y-scroll">



                                  
                                        <div class="">
                                            <label class="text-xs" for="code">
                                                Code<span class="text-red-400">*</span>
                                            </label>
                                            <input id="code" type="text" v-model="popupData1.code" required
                                                class="border border-gray-300 rounded-md text-sm w-full p-2" />
                                        </div>




                                        <div>
                                            <label class="text-xs" for="domain">Domain<span class="text-red-400">*</span></label>
                                            <input id="domain" type="text" v-model="popupData1.domain" required
                                                class="border border-gray-300 rounded-md text-sm w-full p-2" />
                                        </div>
                                        <div>
                                            <label class="text-xs" for="title">Title<span class="text-red-400">*</span></label>
                                            <input id="title" type="text" v-model="popupData1.title" required
                                                class="border border-gray-300 rounded-md text-sm w-full p-2" />
                                        </div>




                                        <div>
                                            <label class="text-xs" for="size">Unit size<span class="text-red-400">*</span></label>
                                            <input id="size" type="number" v-model="popupData1.unit_size" required
                                                class="border border-gray-300 rounded-md text-sm w-full p-2" />
                                        </div>


                                        <div class="flex justify-start items-center gap-2">
                                            <label class="text-xs" for="freeCourse"> Assignments </label>
                                            <input id="Assessments" type="checkbox" class=""
                                                v-model="popupData1.Assignment" required />
                                        </div>
                                        <div>
                                            <label class="text-xs" for="assessmentDetails">Numbar of assignment<span
                                                    class="text-red-400">*</span></label>
                                            <input id="assessmentDetails" type="number"
                                                class="border border-gray-300 rounded-md text-sm w-full p-2" required
                                                v-model="popupData1.Assignment_size" placeholder="" />
                                        </div>

                                        <div class="flex justify-start items-center gap-2">
                                            <label class="text-xs" for="freeCourse"> Quizs </label>
                                            <input id="Quiz" type="checkbox" class="" v-model="popupData1.quiz" required
                                                checked="" />
                                        </div>

                                        <div>
                                            <label class="text-xs" for="quizDetails">Number of quizs<span
                                                    class="text-red-400">*</span></label>
                                            <input id="quizDetails" type="number"
                                                class="border border-gray-300 rounded-md text-sm w-full p-2" required
                                                v-model="popupData1.quiz_size" placeholder="" />
                                        </div>
                                        <div>
                                            <label class="text-xs" for="instruction"> Course instruction promt<span
                                                    class="text-red-400">*</span></label>
                                            <textarea name="" required v-model="popupData1.instruction" id="instruction"
                                                cols="20" rows="4"
                                                class="border border-gray-300 rounded-md text-sm w-full p-2">
            </textarea>
                                        </div>



                                    </div>
                                    <div class="flex justify-between w-full items-center">
                                        <div class="text-sm">
                                            <p class="text-green-400" v-if="message">{{ message }}</p>
                                            <p class="text-red-400" v-if="error_message">{{ error_message }}</p>
                                        </div>

                                        <div class="flex justify-end">
                                            <button type="submit" class="bg-[#0f172a] text-white text-xs rounded-lg px-4 py-2 mt-4">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>


    </div>



</template>


<script>

import axios from "axios";
import {
    mapGetters
} from "vuex";

import Header from "@/components/Admin/Header.vue";

export default {
    
    data(){
        return {
            coursepromt: [],
            promptListCourse: [],
            popupforPreview: false,
            openCoursePreviewStatus: false,
            popupData1: [],
            //   popupData2: {},
            unitpromptList: [],
            unitsubmitpopup: false,
            edit_title: "",
            edit_unit: "",
            edit_instruction: "",
            unitid: "",
            course_prompt_id: '',
            course_prompt_response: [],
            message: "",
            error_message: '',
            genaraic: [],
            popup_instructor: false,
            popup_regenerate: false,
            regenerate_status: false,
            regenerate_message: "",
            loader: false,
            loader_generator: false
        }
    },

    components: {
        Header
    },

    computed: mapGetters(["userInfo", "instructorInfo"]),

    created(){
        this.promptList();
    },
    methods: {

        tiggerGemimi(id) {
            this.popup_regenerate = true;
            this.loader = true;
            this.course_prompt_id = id;
            this.generatecourse();
        },

        async generatecourse() {
            await axios
                .get(
                    `${process.env.VUE_APP_API}/gemini/post/${this.course_prompt_id}/?Key=${this.userInfo.token_key}`,
                )
                .then((resp) => {
                    if (resp.data.status == 200) {
                        this.genaraic = resp.data;
                        this.loader = false;
                        this.loader_generator = false;
                        this.regenerate_status = true;
                        this.regenerate_message = "Regenrated Succesfully..!";
                        setTimeout(() => {
                            this.popup_regenerate = false;
                            this.regenerate_status = false;
                        }, 2000)
                        if (this.popup_instructor) {
                            this.popup_instructor = false
                            this.message = "";

                        }
                        // this.promptList();
                    }
                })
                .catch((err) => {
                    console.log("error", err);
                });


        },

        openPreviewPopup(id) {
            this.course_prompt_id = id;
            this.popupforPreview = true;

            axios.get(`${process.env.VUE_APP_API}/courseprompt/get/?Key=${this.userInfo.token_key}&id=${id}`)
                .then((response) => {
                    if (response.status == 200) {
                        this.popupData1 = response.data.data[0];
                    }
                    else {
                        console.log('response.data.data[0]')
                        console.log("error on api");
                    }
                })
                .catch((err) => {
                    console.log(err);
                })

        },

        promptList() {
            axios.get(`${process.env.VUE_APP_API}/courseprompt/get/?Key=${this.userInfo.token_key}`)
                .then((response) => {
                    if (response.status == 200) {
                        this.promptListCourse = response.data.data;

                    }
                    else {
                        console.log("error on api");
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        },

         coursePromptUpdate() {
            console.log("courseupdate data")
            const instruction = typeof this.popupData1.instruction === 'string'
                ? this.popupData1.instruction.trim()
                : String(this.popupData1.instruction).trim();
            const promptData = {
                batch: this.popupData1.batch,
                code: this.popupData1.code,
                title: this.popupData1.title,
                domain: this.popupData1.domain,
                unit_size: this.popupData1.unit_size,
                // instruction: [
                //     this.popupData1.instruction,
                // ],
                instruction: [
                    instruction.endsWith(',')
                        ? instruction
                        : `${instruction},`
                ],
                Assignment: this.popupData1.Assignment,
                quiz: this.popupData1.quiz,
                Assignment_size: this.popupData1.Assignment_size,
                quiz_size: this.popupData1.quiz_size,
            };
            axios.put(`${process.env.VUE_APP_API}/coursepromptupdate/${this.course_prompt_id}/?Key=${this.userInfo.token_key}`, promptData)
                .then((resp) => {
                    if (resp.status == 200) {
                        this.course_prompt_response = resp.data;
                        this.course_prompt_id = resp.data.data.id;
                        this.message = resp.data.message;
                        setTimeout(() => {
                            this.message="";
                            this.popupforPreview = false;
                            this.popup_instructor = true;
                            this.promptList();
                        }, 3000)
                        this.generatecourse();
                    }
                })
                .catch((err) => {
                    console.log("error", err);
                })
        },

    }
}
</script>


<style scoped>

.lds-ring,
.lds-ring div {
    box-sizing: border-box;
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 60px;
    height: 60px;
    color: #18469d;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 44px;
    height: 44px;
    margin: 4px;
    border: 4px solid currentColor;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: currentColor transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

</style>